// Auto-generated from Katalog kartografických symbolů DTM ČR v1.4.3
// Source: ČÚZK - Značkový klíč objektů DTM ČR
// Do not edit manually — regenerate from jvf_parser/scripts/extract_symbology.py

export interface SymbolVariant {
  /** Attribute key (e.g. 'kategorie pozemní komunikace') */
  attrKey: string | null;
  /** Attribute value (e.g. 'dálnice I. třídy') */
  attrValue: string;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  lineStyle?: string;
  lineSvg?: string;
}

export interface ObjectSymbology {
  /** 10-digit DTM object type code */
  code: string;
  /** Czech name from katalog */
  objectType: string;
  /** Obsahová část: ZPS, DI, TI, GAD, OPL */
  containsPart: string;
  /** Primary geometry type in katalog */
  geometryType: string;
  /** Polygon fill color (hex) */
  fillColor?: string;
  /** Stroke/border color (hex) */
  strokeColor?: string;
  /** Line style description */
  lineStyle?: string;
  /** Stroke width in mm */
  strokeWidth?: number;
  /** SVG filename for point symbol (from kartografický balíček) */
  pointSvg?: string;
  /** SVG filename for line symbol */
  lineSvg?: string;
  /** Per-attribute-value style variants (e.g. road category) */
  variants?: SymbolVariant[];
}

/**
 * Symbology lookup by DTM object type codeBase (10-digit string).
 * Matches ObjektovyTyp.codeBase from jvf-parser.
 */
export const SYMBOLOGY: Record<string, ObjectSymbology> = {
  '0100000001': {
    code: '0100000001',
    objectType: 'budova',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ebe9e8',
    strokeColor: '#d6d4d4',
    lineStyle: 'plná',
    strokeWidth: 1.6,
    pointSvg: 'ZPS_db.svg',
  },
  '0100000003': {
    code: '0100000003',
    objectType: 'obvod pozemní komunikace',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000004': {
    code: '0100000004',
    objectType: 'osa pozemní komunikace',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 60,0 6,0 [68]',
    strokeWidth: 0.7,
    lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_d1.svg',
    variants: [
      {
        attrKey: null,
        attrValue: 'dálnice II. třídy',
        fillColor: '#000000',
        strokeWidth: 0.7,
        lineStyle: 'čárkovaná 60,0 7,0 [69]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_d2.svg',
      },
      {
        attrKey: null,
        attrValue: 'silnice I. třídy',
        fillColor: '#000000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 60,0 5,0 [67]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_s1.svg',
      },
      {
        attrKey: null,
        attrValue: 'silnice II. třídy',
        fillColor: '#000000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 60,0 6,0 [68]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_s2.svg',
      },
      {
        attrKey: null,
        attrValue: 'silnice III. třídy',
        fillColor: '#000000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 60,0 7,0 [69]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_s3.svg',
      },
      {
        attrKey: null,
        attrValue: 'místní komunikace I. třídy',
        fillColor: '#000000',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 60,0 9,0 [71]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_mk1.svg',
      },
      {
        attrKey: null,
        attrValue: 'místní komunikace II. třídy',
        fillColor: '#000000',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 60,0 10,0 [72]',
        lineSvg: 'DI_l_004_siln_dopr_osa_poz_kom_mk2.svg',
      },
      {
        attrKey: null,
        attrValue: 'místní komunikace III. třídy',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineStyle: 'plná',
      },
      {
        attrKey: null,
        attrValue: 'místní komunikace IV. třídy',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineStyle: 'plná',
      },
      {
        attrKey: null,
        attrValue: 'účelové komunikace',
        strokeWidth: 0.25,
        lineStyle: 'plná',
      },
      {
        attrKey: null,
        attrValue: 'neveřejně přístupná\núčelová komunikace',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineStyle: 'plná',
      },
      {
        attrKey: null,
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineStyle: 'plná',
      },
    ],
  },
  '0100000005': {
    code: '0100000005',
    objectType: 'provozní plocha pozemní komunikace',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000007': {
    code: '0100000007',
    objectType: 'chodník',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#fffee8',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000009': {
    code: '0100000009',
    objectType: 'cyklostezka',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    strokeWidth: 0.25,
    pointSvg: 'ZPS_db.svg',
  },
  '0100000011': {
    code: '0100000011',
    objectType: 'parkoviště, odstavná plocha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000013': {
    code: '0100000013',
    objectType: 'dopravní ostrůvek',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000015': {
    code: '0100000015',
    objectType: 'dělící pás',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000017': {
    code: '0100000017',
    objectType: 'nájezd',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000019': {
    code: '0100000019',
    objectType: 'obvod dráhy',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000020': {
    code: '0100000020',
    objectType: 'osa železniční tratě',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 6,0 6,0',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: null,
        attrValue: 'regionální',
        fillColor: '#000000',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 6,0 6,0',
      },
      {
        attrKey: null,
        attrValue: 'místní',
        fillColor: '#000000',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 6,0 6,0',
      },
      {
        attrKey: null,
        attrValue: 'vlečka',
      },
      {
        attrKey: null,
        attrValue: 'zkušební',
      },
      {
        attrKey: null,
        attrValue: 'jiná',
      },
      {
        attrKey: null,
        attrValue: 'nezjištěno',
      },
    ],
  },
  '0100000021': {
    code: '0100000021',
    objectType: 'osa koleje železniční tratě',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.35,
  },
  '0100000022': {
    code: '0100000022',
    objectType: 'železniční přejezd',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#b9bee4',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000024': {
    code: '0100000024',
    objectType: 'tramvajová dráha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#f0eceb',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000026': {
    code: '0100000026',
    objectType: 'osa tramvajové dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
  },
  '0100000027': {
    code: '0100000027',
    objectType: 'osa koleje tramvajové dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000028': {
    code: '0100000028',
    objectType: 'pozemní lanová dráha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000030': {
    code: '0100000030',
    objectType: 'osa pozemní lanové dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeWidth: 0.35,
    lineSvg: 'DI_l_030_dr_dopr_poz_lan_dr.svg',
  },
  '0100000031': {
    code: '0100000031',
    objectType: 'osa koleje pozemní lanové dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.35,
  },
  '0100000035': {
    code: '0100000035',
    objectType: 'speciální dráha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000037': {
    code: '0100000037',
    objectType: 'osa speciální dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
  },
  '0100000038': {
    code: '0100000038',
    objectType: 'osa koleje speciální dráhy',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 2,0 2,0',
    strokeWidth: 0.35,
  },
  '0100000039': {
    code: '0100000039',
    objectType: 'visutá lanová dráha',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 2,0 2,0 [40]',
    strokeWidth: 0.35,
    lineSvg: 'ZPS_l_039_dopr_st_vis_lan_dr.svg',
  },
  '0100000040': {
    code: '0100000040',
    objectType: 'dopravně významné místo na dráze',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'DI_b_040_dopr_vyzn_misto_na_draze.svg',
      },
    ],
  },
  '0100000041': {
    code: '0100000041',
    objectType: 'plavební komora',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#d9e1f2',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#0000ff',
        strokeWidth: 1.0,
        lineSvg: 'DI_b_041_vod_dopr_plav_kom.svg',
      },
    ],
  },
  '0100000043': {
    code: '0100000043',
    objectType: 'sledovaná vodní cesta',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#d9e1f2',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.35,
  },
  '0100000045': {
    code: '0100000045',
    objectType: 'vodní část přístavu',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#d9e1f2',
    strokeColor: '#0000ff',
    lineStyle: 'plná',
    strokeWidth: 1.2,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#0000ff',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_045_vod_cast_pristavu_500.svg, DI_b_045_vod_cast_pristavu_5000.svg',
      },
    ],
  },
  '0100000046': {
    code: '0100000046',
    objectType: 'vzletová a přistávací dráha',
    containsPart: 'DI',
    geometryType: 'plocha',
    lineStyle: 'plná',
    strokeWidth: 1.2,
  },
  '0100000047': {
    code: '0100000047',
    objectType: 'letiště',
    containsPart: 'DI',
    geometryType: 'plocha',
    lineStyle: 'plná',
    strokeWidth: 1.2,
    pointSvg: 'DI_p_047_let_dopr_let_lab.svg',
  },
  '0100000048': {
    code: '0100000048',
    objectType: 'heliport',
    containsPart: 'DI',
    geometryType: 'plocha',
    lineStyle: 'plná',
    strokeWidth: 1.2,
    pointSvg: 'DI_b_048_let_dopr_heliport.svg',
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        strokeWidth: 1.0,
        lineSvg: 'DI_b_048_let_dopr_heliport.svg',
      },
    ],
  },
  '0100000049': {
    code: '0100000049',
    objectType: 'letecká stavba',
    containsPart: 'DI',
    geometryType: 'plocha',
    lineStyle: 'plná',
    strokeWidth: 1.2,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'DI_b_049_let_dopr_let_st.svg',
      },
    ],
  },
  '0100000050': {
    code: '0100000050',
    objectType: 'zařízení pro letecký provoz',
    containsPart: 'DI',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.5,
    pointSvg: 'DI_b_050_let_dopr_zar_let_prov.svg',
  },
  '0100000051': {
    code: '0100000051',
    objectType: 'příkop, násep, zářez dopravní stavby',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000053': {
    code: '0100000053',
    objectType: 'nástupiště',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000055': {
    code: '0100000055',
    objectType: 'manipulační plocha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000057': {
    code: '0100000057',
    objectType: 'obvod mostu',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000058': {
    code: '0100000058',
    objectType: 'plocha mostní kontrukce',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    strokeColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000060': {
    code: '0100000060',
    objectType: 'portál tunelu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000062': {
    code: '0100000062',
    objectType: 'provozní plocha tunelu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    strokeColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000064': {
    code: '0100000064',
    objectType: 'portál podchodu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000066': {
    code: '0100000066',
    objectType: 'provozní plocha podchodu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    strokeColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000068': {
    code: '0100000068',
    objectType: 'stojan nabíjení, výdejní stojan',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.5,
    pointSvg: 'ZPS_b_068_dopr_st_nab_stojan.svg',
  },
  '0100000070': {
    code: '0100000070',
    objectType: 'mostní váha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000072': {
    code: '0100000072',
    objectType: 'nádrž, zdrž se vzdouvacím objektem',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#e6f6ff",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000076': {
    code: '0100000076',
    objectType: 'stupeň',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_076_vod_dila_stupen.svg',
      },
    ],
  },
  '0100000078': {
    code: '0100000078',
    objectType: 'stavebně upravené koryto',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000080': {
    code: '0100000080',
    objectType: 'meliorační příkop, žlab',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000082': {
    code: '0100000082',
    objectType: 'osa melioračního příkopu, žlabu, drénu',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000083': {
    code: '0100000083',
    objectType: 'meliorační šachta',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.5,
    pointSvg: 'ZPS_b_083_vod_dila_melior_sachta.svg',
  },
  '0100000084': {
    code: '0100000084',
    objectType: 'studna na veřejném prostranství',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 1.5,
    pointSvg: 'ZPS_b_084_prisl_st_studna_500.svg',
  },
  '0100000085': {
    code: '0100000085',
    objectType: 'protipovodňová zábrana',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000087': {
    code: '0100000087',
    objectType: 'suchá nádrž',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000089': {
    code: '0100000089',
    objectType: 'objekt nebo zařízení k ochraně před povodněmi',
    containsPart: 'TI',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.0,
    pointSvg: 'TI_b_089_vod_dila_obj_ochr_povod.svg',
  },
  '0100000091': {
    code: '0100000091',
    objectType: 'kolektor',
    containsPart: 'TI',
    geometryType: 'linie',
    lineStyle: 'čárkovaná 36,0 8,0 [46]',
    strokeWidth: 0.13,
    pointSvg: 'TI_l_091_sdil_st_ti_kol.svg',
  },
  '0100000092': {
    code: '0100000092',
    objectType: 'technický kanál',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'chránička',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_chran.svg',
      },
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'kabelovod',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_kabelovod.svg',
      },
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'technický podpovrchový kanál',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_podpovrch_kanal.svg',
      },
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'kabelová lávka / žlab',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_lavka_zlab.svg',
      },
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'jiná ochranná konstrukce',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_jina.svg',
      },
      {
        attrKey: 'typ technického kanálu',
        attrValue: 'nezjištěno',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_092_sdil_st_ti_tech_kanal_nezj.svg',
      },
    ],
  },
  '0100000093': {
    code: '0100000093',
    objectType: 'sdílený objekt TI',
    containsPart: 'TI',
    geometryType: 'bod',
    fillColor: '#343434',
    strokeWidth: 1.0,
    pointSvg: 'TI_b_093_sdil_st_ti.svg',
  },
  '0100000095': {
    code: '0100000095',
    objectType: 'podpěrné zařízení',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'stožár příhradový',
        fillColor: '#343434',
        strokeWidth: 1.2,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_stoz_prihr.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'stožár jiný',
        fillColor: '#343434',
        strokeWidth: 1.2,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_stoz_jiny.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'sloup elektrického veřejného osvětlení',
        fillColor: '#343434',
        strokeWidth: 1.5,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_sl_el_ver_osvl.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'sloup plynového veřejného osvětlení',
        fillColor: '#4ce600',
        strokeWidth: 1.5,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_sl_plyn_ver_osvl.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'sloup trakčního vedení',
        fillColor: '#343434',
        strokeWidth: 1.2,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_sl_tr_ved.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'sloup jiný',
        fillColor: '#343434',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_sl_jiny.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'nástěnná konzola',
        fillColor: '#343434',
        strokeWidth: 1.5,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_nast_konz.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'střešník',
        fillColor: '#343434',
        strokeWidth: 0.8,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_stresnik.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'portál',
        fillColor: '#343434',
        strokeWidth: 1.2,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_port.svg',
      },
      {
        attrKey: 'podpěrné zařízení',
        attrValue: 'hák',
        fillColor: '#343434',
        strokeWidth: 0.8,
        lineSvg: 'TI_b_095_sdil_st_ti_podp_hak.svg',
      },
    ],
  },
  '0100000096': {
    code: '0100000096',
    objectType: 'jiná technologická stavba TI',
    containsPart: 'TI',
    geometryType: 'bod',
    fillColor: '#343434',
    strokeWidth: 2.0,
    pointSvg: 'TI_b_096_sdil_st_ti_jina.svg',
  },
  '0100000097': {
    code: '0100000097',
    objectType: 'průběh jiné technologické stavby TI',
    containsPart: 'TI',
    geometryType: 'linie',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000098': {
    code: '0100000098',
    objectType: 'trasa elektrické sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'NN',
        fillColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 7,0 [45]',
        lineSvg: 'TI_l_098_el_ved_trasa_nn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VN',
        fillColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 7,0 [45]',
        lineSvg: 'TI_l_098_el_ved_trasa_vn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VVN',
        fillColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 7,0 [45]',
        lineSvg: 'TI_l_098_el_ved_trasa_vvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'ZVN',
        fillColor: '#e60000',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 7,0 [45]',
        lineSvg: 'TI_l_098_el_ved_trasa_zvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'nezjištěno',
        fillColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '0100000099': {
    code: '0100000099',
    objectType: 'trasa místní elektrické sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#e60000',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000100': {
    code: '0100000100',
    objectType: 'trasa odběrného elektrického zařízení',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#e60000',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000101': {
    code: '0100000101',
    objectType: 'zařízení elektrické sítě',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ zařízení elektrické sítě',
        attrValue: 'skříň elektrické sítě',
        fillColor: '#e60000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_101_el_ved_zar_skrin.svg',
      },
      {
        attrKey: 'typ zařízení elektrické sítě',
        attrValue: 'jiné',
        fillColor: '#e60000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_101_el_ved_zar_jine.svg',
      },
    ],
  },
  '0100000102': {
    code: '0100000102',
    objectType: 'výrobna elektřiny s instalovaným výkonem nad 50 kW',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#f2cece',
    strokeColor: '#e60000',
    lineStyle: 'plná',
    strokeWidth: 0.13,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_102_el_ved_vyr.svg',
      },
    ],
  },
  '0100000103': {
    code: '0100000103',
    objectType: 'stanice elektrické sítě',
    containsPart: 'TI',
    geometryType: 'plocha nebo bod',
    variants: [
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'NN',
        fillColor: '#f2cece',
        strokeColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_103_el_ved_st_nn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VN',
        fillColor: '#f2cece',
        strokeColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_103_el_ved_st_vn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VVN',
        fillColor: '#f2cece',
        strokeColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_103_el_ved_st_vvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'ZVN',
        fillColor: '#f2cece',
        strokeColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_103_el_ved_st_zvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'nezjištěno',
        fillColor: '#f2cece',
        strokeColor: '#e60000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_103_el_ved_st_nezj.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'NN',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_103_el_ved_st_nn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VN',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_103_el_ved_st_vn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VVN',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_103_el_ved_st_vvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'ZVN',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_103_el_ved_st_zvn.svg',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_103_el_ved_st_nezj.svg',
      },
    ],
  },
  '0100000104': {
    code: '0100000104',
    objectType: 'jaderné zařízení',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.7,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_104_el_ved_jader.svg',
      },
    ],
  },
  '0100000105': {
    code: '0100000105',
    objectType: 'trasa sítě EK',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#c500ff',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000106': {
    code: '0100000106',
    objectType: 'trasa rádiového směrového spoje',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#e180ff',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000107': {
    code: '0100000107',
    objectType: 'zařízení sítě EK',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'Typ zařízení sítě EK',
        attrValue: 'venkovní rozvaděč EK',
        fillColor: '#c500ff',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_107_el_kom_zar_rozvadec.svg',
      },
      {
        attrKey: 'Typ zařízení sítě EK',
        attrValue: 'bod pro přístup nebo propojení sítí EK uvnitř budov',
        fillColor: '#c500ff',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_107_el_kom_zar_prist_bod.svg',
      },
    ],
  },
  '0100000108': {
    code: '0100000108',
    objectType: 'technologický objekt sítě EK',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#edb3ff',
    strokeColor: '#c500ff',
    lineStyle: 'plná',
    strokeWidth: 0.13,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#c500ff',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_108_el_kom_zar_tech_obj.svg',
      },
    ],
  },
  '0100000109': {
    code: '0100000109',
    objectType: 'trasa plynovodní sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'NTL',
        fillColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_109_plyn_trasa_ntl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'STL',
        fillColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_109_plyn_trasa_stl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VTL',
        fillColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_109_plyn_trasa_vtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VVTL',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_109_plyn_trasa_tlak_vvtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'nezjištěno',
        fillColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '0100000110': {
    code: '0100000110',
    objectType: 'trasa odběrného plynového zařízení',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#4ce600',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000111': {
    code: '0100000111',
    objectType: 'zařízení plynovodní sítě',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ zařízení plynovodní sítě',
        attrValue: 'šoupě',
        fillColor: '#4ce600',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_111_plyn_zar_soupe.svg',
      },
      {
        attrKey: 'typ zařízení plynovodní sítě',
        attrValue: 'skříň',
        fillColor: '#4ce600',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_111_plyn_zar_skrin.svg',
      },
      {
        attrKey: 'typ zařízení plynovodní sítě',
        attrValue: 'šachta',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_111_plyn_zar_sach.svg',
      },
      {
        attrKey: 'typ zařízení plynovodní sítě',
        attrValue: 'jiné',
        fillColor: '#4ce600',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_111_plyn_zar_jine.svg',
      },
    ],
  },
  '0100000112': {
    code: '0100000112',
    objectType: 'technologický objekt plynovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'NTL',
        fillColor: '#dcffcc',
        strokeColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_112_plyn_tech_obj_ntl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'STL',
        fillColor: '#dcffcc',
        strokeColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_112_plyn_tech_obj_stl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VTL',
        fillColor: '#dcffcc',
        strokeColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_112_plyn_tech_obj_vtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VVTL',
        fillColor: '#dcffcc',
        strokeColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_112_plyn_tech_obj_vvtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'nezjištěno',
        fillColor: '#dcffcc',
        strokeColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_112_plyn_tech_obj_nezj.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'NTL',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_112_plyn_tech_obj_ntl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'STL',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_112_plyn_tech_obj_stl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VTL',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_112_plyn_tech_obj_vtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VVTL',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_112_plyn_tech_obj_vvtl.svg',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'nezjištěno',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_112_plyn_tech_obj_nezj.svg',
      },
    ],
  },
  '0100000114': {
    code: '0100000114',
    objectType: 'trasa vodovodní přípojky',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#005ce6',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000116': {
    code: '0100000116',
    objectType: 'zařízení vodovodní přípojky',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#005ce6',
    variants: [
      {
        attrKey: 'Typ zařízení vodovodní přípojky',
        attrValue: 'šachta měrná a kontrolní',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_116_vod_prip_zar_mer_kontr.svg',
      },
      {
        attrKey: 'Typ zařízení vodovodní přípojky',
        attrValue: 'jiné',
        fillColor: '#005ce6',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_116_vod_prip_zar_jine.svg',
      },
    ],
  },
  '0100000118': {
    code: '0100000118',
    objectType: 'přivaděč, náhon, odpad',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    lineStyle: 'plná',
    strokeWidth: 0.13,
    variants: [
      {
        attrKey: null,
        attrValue: 'linie',
        fillColor: '#005ce6',
        strokeWidth: 0.5,
        lineStyle: 'plná',
      },
    ],
  },
  '0100000119': {
    code: '0100000119',
    objectType: 'zařízení přivaděče',
    containsPart: 'TI',
    geometryType: 'bod',
    strokeWidth: 2.0,
    pointSvg: 'TI_b_119_zar_privadece_sach.svg',
    variants: [
      {
        attrKey: null,
        attrValue: 'jiné',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_119_zar_privadece_jine.svg',
      },
      {
        attrKey: null,
        attrValue: 'nezjištěno',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_119_zar_privadece_nezj.svg',
      },
    ],
  },
  '0100000122': {
    code: '0100000122',
    objectType: 'trasa kanalizační přípojky',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#915904',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000124': {
    code: '0100000124',
    objectType: 'zařízení kanalizační přípojky',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'revizní šachta',
        fillColor: '#915904',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'měrná šachta',
        fillColor: '#915904',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'domovní čerpací stanice',
        fillColor: '#915904',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'vsakovací zařízení s přepadem',
        fillColor: '#915904',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'jiné',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'revizní šachta',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'ZPS_b_124_kan_prip_zar_sachta_rev.svg',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'měrná šachta',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'ZPS_b_124_kan_prip_zar_sachta_mer.svg',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'domovní čerpací stanice',
        fillColor: '#915904',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_124_kan_prip_zar_cerp_st.svg',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'vsakovací zařízení s přepadem',
        fillColor: '#915904',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_124_kan_prip_zar_vs_prep.svg',
      },
      {
        attrKey: 'typ zařízení kanalizační přípojky',
        attrValue: 'jiné',
        fillColor: '#915904',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_124_kan_prip_zar_jine.svg',
      },
    ],
  },
  '0100000127': {
    code: '0100000127',
    objectType: 'trasa sítě produktovodu',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#73004c',
    lineStyle: 'čárkovaná 36,0 8,0 [46]',
    strokeWidth: 0.13,
    lineSvg: 'TI_l_127_produkt_trasa.svg',
  },
  '0100000128': {
    code: '0100000128',
    objectType: 'zařízení sítě produktovodu',
    containsPart: 'TI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ zařízení sítě produktovodu',
        attrValue: 'šachta',
        fillColor: '#73004c',
      },
      {
        attrKey: 'typ zařízení sítě produktovodu',
        attrValue: 'nezjištěno',
        fillColor: '#73004c',
      },
      {
        attrKey: 'typ zařízení sítě produktovodu',
        attrValue: 'šachta',
        fillColor: '#73004c',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_128_produkt_zar_sach.svg',
      },
      {
        attrKey: 'typ zařízení sítě produktovodu',
        attrValue: 'nezjištěno',
        fillColor: '#73004c',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_128_produkt_zar_nezj.svg',
      },
    ],
  },
  '0100000129': {
    code: '0100000129',
    objectType: 'technologický objekt sítě produktovodu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#ccb4c4',
    strokeColor: '#73004c',
    lineStyle: 'plná',
    strokeWidth: 0.13,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#73004c',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_129_produkt_tech_obj.svg',
      },
    ],
  },
  '0100000131': {
    code: '0100000131',
    objectType: 'zařízení teplovodní sítě',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ zařízení teplovodní sítě',
        attrValue: 'odvětrávání teplovodu',
        fillColor: '#ff7d00',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_131_teplo_zar_telp_odv.svg',
      },
      {
        attrKey: 'typ zařízení teplovodní sítě',
        attrValue: 'šachta',
        fillColor: '#ff7d00',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_131_teplo_zar_tepl_sacht.svg',
      },
      {
        attrKey: 'typ zařízení teplovodní sítě',
        attrValue: 'jiné',
        fillColor: '#ff7d00',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_131_teplo_zar_jine.svg',
      },
    ],
  },
  '0100000132': {
    code: '0100000132',
    objectType: 'technologický objekt teplovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#ffeecf',
    strokeColor: '#ff7d00',
    lineStyle: 'plná',
    strokeWidth: 0.13,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#ff7d00',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_132_teplo_tech_obj.svg',
      },
    ],
  },
  '0100000133': {
    code: '0100000133',
    objectType: 'trasa potrubní pošty',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#00dcaa',
    lineStyle: 'čárkovaná 36,0 8,0 [46]',
    strokeWidth: 0.13,
    lineSvg: 'TI_l_133_potrub_posta_trasa.svg',
  },
  '0100000134': {
    code: '0100000134',
    objectType: 'zařízení potrubní pošty',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ zařízení potrubní pošty',
        attrValue: 'šoupě',
        fillColor: '#00dcaa',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_134_potrub_posta_zar_soupe.svg',
      },
      {
        attrKey: 'typ zařízení potrubní pošty',
        attrValue: 'jiné',
        fillColor: '#00dcaa',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_134_potrub_posta_zar_jine.svg',
      },
    ],
  },
  '0100000135': {
    code: '0100000135',
    objectType: 'povrchový znak TI',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'šachta vstupní',
        fillColor: '#000000',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_sacht_vstup.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'šachta kabelovodní',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_sacht_kabel.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'zařízení elektrické sítě',
        fillColor: '#e60000',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_el_sit.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'zařízení sítě EK',
        fillColor: '#c500ff',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_ek.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'zařízení plynovodní sítě',
        fillColor: '#4ce600',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_plyn.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'objekt vodovodní sítě',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_vod.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'objekt stokové sítě',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_kan.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'zařízení sítě produktovodu',
        fillColor: '#73004c',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_produkt.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'zařízení teplovodní sítě',
        fillColor: '#ff7d00',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_tepl.svg',
      },
      {
        attrKey: 'typ povrchového znaku TI',
        attrValue: 'jiný',
        fillColor: '#000000',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_135_zar_st_ti_pov_znak_jiny.svg',
      },
    ],
  },
  '0100000136': {
    code: '0100000136',
    objectType: 'orientační sloupek TI',
    containsPart: 'TI',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.5,
    pointSvg: 'TI_b_136_zar_st_ti_or_sl.svg',
  },
  '0100000140': {
    code: '0100000140',
    objectType: 'důl, lom',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#ded6cc",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000142': {
    code: '0100000142',
    objectType: 'plocha rekultivace',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#dee3d1",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000144': {
    code: '0100000144',
    objectType: 'úložné místo těžebního odpadu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#e8e5e1",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000146': {
    code: '0100000146',
    objectType: 'jiné důlní dílo, důlní stavba',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#ded6cc",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000148': {
    code: '0100000148',
    objectType: 'skládka odpadů',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_148_odp_hosp_skl_odp.svg',
      },
    ],
  },
  '0100000149': {
    code: '0100000149',
    objectType: 'spalovna',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_149_odp_hosp_spal.svg',
      },
    ],
  },
  '0100000150': {
    code: '0100000150',
    objectType: 'jiné zařízení na odstraňování, využívání nebo sběr odpadů',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_150_odp_hosp_odp_jine.svg',
      },
    ],
  },
  '0100000151': {
    code: '0100000151',
    objectType: 'odkaliště',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_151_odp_hosp_odk.svg',
      },
    ],
  },
  '0100000152': {
    code: '0100000152',
    objectType: 'hřiště',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#fffadb',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000154': {
    code: '0100000154',
    objectType: 'drobná sakrální stavba',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeColor: '#d2d2d2',
    strokeWidth: 3.0,
    pointSvg: 'ZPS_db.svg',
  },
  '0100000157': {
    code: '0100000157',
    objectType: 'hřbitov',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#d2d4bc",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000159': {
    code: '0100000159',
    objectType: 'drobná kulturní stavba',
    containsPart: 'ZPS',
    geometryType: 'bod',
    pointSvg: 'ZPS_db.svg',
    variants: [
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'kašna',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_159_st_kult_kas.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'vodotrysk, fontána',
        fillColor: '#000000',
        strokeWidth: 2.5,
        lineSvg: 'ZPS_b_159_st_kult_vodotr_font.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'pomník',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'ZPS_b_159_st_kult_pom.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'socha',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'ZPS_b_159_st_kult_socha.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'mohyla',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'ZPS_b_159_st_kult_moh.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'zvonice',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'ZPS_b_159_st_kult_zvon.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_159_st_kult_nezj.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'kašna',
        fillColor: "#d2d2d2",
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'vodotrysk, fontána',
        fillColor: '#d2d2d2',
        lineSvg: 'ZPS_p_159_zps_pl_dr_kult_st_vodotr_font_lab.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'pomník',
        fillColor: '#d2d2d2',
        lineSvg: 'ZPS_p_159_zps_pl_dr_kult_st_pom_lab.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'socha',
        fillColor: '#d2d2d2',
        lineSvg: 'ZPS_p_159_zps_pl_dr_kult_st_socha_lab.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'mohyla',
        fillColor: "#d2d2d2",
        lineSvg: 'ZPS_p_159_zps_pl_dr_kult_st_moh_lab.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'zvonice',
        fillColor: '#d2d2d2',
        lineSvg: 'ZPS_p_159_zps_pl_dr_kult_st_zvon_lab.svg',
      },
      {
        attrKey: 'typ drobné kulturní stavby',
        attrValue: 'zvonice',
        fillColor: '#d2d2d2',
        lineSvg: 'ZPS_b_159_st_kult_nezj.svg',
      },
    ],
  },
  '0100000162': {
    code: '0100000162',
    objectType: 'plot',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeColor: '#000000',
    lineStyle: 'čárkovaná 0,15 10,0',
    strokeWidth: 0.18,
  },
  '0100000163': {
    code: '0100000163',
    objectType: 'podezdívka',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000165': {
    code: '0100000165',
    objectType: 'stavebně upravený vjezd na pozemek',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000166': {
    code: '0100000166',
    objectType: 'schodiště',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#fffee8',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000168': {
    code: '0100000168',
    objectType: 'zeď',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    pointSvg: 'ZPS_db.svg',
    variants: [
      {
        attrKey: 'typ zdi',
        attrValue: 'městské hradby',
        fillColor: '#ccc5ba',
      },
      {
        attrKey: 'typ zdi',
        attrValue: 'volně stojící',
        fillColor: '#d2d2d2',
      },
      {
        attrKey: 'typ zdi',
        attrValue: 'opěrná',
        fillColor: '#d2d2d2',
      },
      {
        attrKey: 'typ zdi',
        attrValue: 'zárubní',
        fillColor: '#d2d2d2',
      },
      {
        attrKey: 'typ zdi',
        attrValue: 'nezjištěno',
        fillColor: '#d2d2d2',
      },
    ],
  },
  '0100000173': {
    code: '0100000173',
    objectType: 'rampa',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000175': {
    code: '0100000175',
    objectType: 'terasa',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000177': {
    code: '0100000177',
    objectType: 'komín',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    strokeColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000179': {
    code: '0100000179',
    objectType: 'skleník',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#d5e0de",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000181': {
    code: '0100000181',
    objectType: 'zahradní bazén',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#deebff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000183': {
    code: '0100000183',
    objectType: 'patka, deska, monolit, pilíř',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000185': {
    code: '0100000185',
    objectType: 'průběh technologické konstrukce',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000186': {
    code: '0100000186',
    objectType: 'sloup technologické konstrukce',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 2.0,
    pointSvg: 'ZPS_b_186_prisl_st_sloup_tech_konstr.svg',
  },
  '0100000187': {
    code: '0100000187',
    objectType: 'stavba pro zpevnění povrchu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000189': {
    code: '0100000189',
    objectType: 'dvůr, nádvoří',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000191': {
    code: '0100000191',
    objectType: 'vrt',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 6.5,
    pointSvg: 'ZPS_b_191_prisl_st_vrt.svg',
  },
  '0100000192': {
    code: '0100000192',
    objectType: 'ochranná šachta vrtu',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 7.0,
    pointSvg: 'ZPS_b_192_prisl_st_sach_vrt.svg',
  },
  '0100000193': {
    code: '0100000193',
    objectType: 'čelo propustku',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000195': {
    code: '0100000195',
    objectType: 'průběh propustku',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 4,0 2,0',
    strokeWidth: 0.13,
  },
  '0100000199': {
    code: '0100000199',
    objectType: 'zábradlí',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeWidth: 0.13,
    lineSvg: 'ZPS_l_199_prisl_st_zabradli.svg',
  },
  '0100000200': {
    code: '0100000200',
    objectType: 'výtah v chodníku',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 3.0,
    pointSvg: 'ZPS_b_200_prisl_st_vytah_chod.svg',
  },
  '0100000201': {
    code: '0100000201',
    objectType: 'nosič technického zařízení',
    containsPart: 'ZPS',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'nosič kamerového systému',
        fillColor: '#000000',
        strokeWidth: 2.0,
        lineSvg: 'ZPS_b_201_prisl_st_nosic_kam_syst.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'informační tabule',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_nosic_tech_zar_inf_tab.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'billboard',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_billb.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'reklamní sloup',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_rekl_sl.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'vlajková stožár',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_vlajk_st.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'sdružený',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_sdruz.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'jiný',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_nezj.svg',
      },
      {
        attrKey: 'typ nosiče technického zařízení',
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'ZPS_b_201_prisl_st_nezj.svg',
      },
    ],
  },
  '0100000202': {
    code: '0100000202',
    objectType: 'neidentifikovaný objekt',
    containsPart: 'ZPS',
    geometryType: 'linie',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000203': {
    code: '0100000203',
    objectType: 'vodní tok',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6f6ff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000205': {
    code: '0100000205',
    objectType: 'jezero',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d9f2ff',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000207': {
    code: '0100000207',
    objectType: 'zemědělská plocha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    pointSvg: 'ZPS_db.svg',
    variants: [
      {
        attrKey: 'typ zemědělské plochy',
        attrValue: 'orná půda',
        fillColor: "#fff9ef",
        lineSvg: 'ZPS_p_207_zps_pl_zem_pl_or_pu_lab.svg',
      },
      {
        attrKey: 'typ zemědělské plochy',
        attrValue: 'vinice',
        fillColor: "#fff9ef",
        lineSvg: 'ZPS_p_207_zps_pl_zem_pl_vin_lab.svg',
      },
      {
        attrKey: 'typ zemědělské plochy',
        attrValue: 'chmelnice',
        fillColor: "#fff9ef",
        lineSvg: 'ZPS_p_207_zps_pl_zem_pl_chmel_lab.svg',
      },
      {
        attrKey: 'typ zemědělské plochy',
        attrValue: 'ovocný sad',
        fillColor: "#fff9ef",
        lineSvg: 'ZPS_p_207_zps_pl_zem_pl_ovo_sad_lab.svg',
      },
      {
        attrKey: 'typ zemědělské plochy',
        attrValue: 'trvalý travní porost',
        fillColor: "#fff9ef",
        lineSvg: 'ZPS_p_207_zps_pl_zem_pl_trav_por_lab.svg',
      },
    ],
  },
  '0100000209': {
    code: '0100000209',
    objectType: 'zahrada',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f9fcf5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000211': {
    code: '0100000211',
    objectType: 'les',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#d3e0bc",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000213': {
    code: '0100000213',
    objectType: 'hospodářsky nevyužívaná plocha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#ffffff",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000215': {
    code: '0100000215',
    objectType: 'udržovaná plocha zeleně',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    pointSvg: 'ZPS_db.svg',
    variants: [
      {
        attrKey: 'typ udržované zeleně',
        attrValue: 'městská parková zeleň',
        fillColor: "#d4f0c2",
        lineSvg: 'ZPS_p_215_zps_pl_udrz_pl_zel_lab.svg',
      },
      {
        attrKey: 'typ udržované zeleně',
        attrValue: 'udržovaná travnatá a okrasná plocha',
        fillColor: '#e3f0d8',
      },
      {
        attrKey: 'typ udržované zeleně',
        attrValue: 'skupina stromů a keřů',
        fillColor: "#e3f0d8",
      },
      {
        attrKey: 'typ udržované zeleně',
        attrValue: 'nezjištěno',
        fillColor: '#e3f0d8',
      },
    ],
  },
  '0100000217': {
    code: '0100000217',
    objectType: 'terénní hrana',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#c2a56b',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000218': {
    code: '0100000218',
    objectType: 'podrobný bod ZPS',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#646464',
    strokeWidth: 0.6,
    pointSvg: 'ZPS_b_218_podr_bod_zps.svg',
  },
  '0100000219': {
    code: '0100000219',
    objectType: 'výškový bod na terénu',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#a87000',
    strokeWidth: 0.8,
    pointSvg: 'ZPS_b_219_podr_bod_vyska.svg',
  },
  '0100000220': {
    code: '0100000220',
    objectType: 'identický bod',
    containsPart: 'ZPS',
    geometryType: 'bod',
    fillColor: '#b20000',
    strokeWidth: 0.8,
    pointSvg: 'ZPS_b_220_podr_bod_ident.svg',
  },
  '0100000279': {
    code: '0100000279',
    objectType: 'ochranné pásmo objektů vodovodu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#005ce6',
    strokeWidth: 0.18,
  },
  '0100000280': {
    code: '0100000280',
    objectType: 'ochranné pásmo objektů kanalizace',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#915904',
    strokeWidth: 0.18,
  },
  '0100000281': {
    code: '0100000281',
    objectType: 'ochranné pásmo elektrické sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e60000',
    strokeWidth: 0.18,
  },
  '0100000282': {
    code: '0100000282',
    objectType: 'ochranné pásmo výrobny elektřiny',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e60000',
    strokeWidth: 0.18,
  },
  '0100000283': {
    code: '0100000283',
    objectType: 'ochranné pásmo plynovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#4ce600',
    strokeWidth: 0.18,
  },
  '0100000284': {
    code: '0100000284',
    objectType: 'ochranné pásmo sítě produktovodu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#73004c',
    strokeWidth: 0.18,
  },
  '0100000285': {
    code: '0100000285',
    objectType: 'ochranné pásmo teplovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#ff7d00',
    strokeWidth: 0.18,
  },
  '0100000286': {
    code: '0100000286',
    objectType: 'ochranné pásmo sítě EK',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#c500ff',
    strokeWidth: 0.18,
  },
  '0100000287': {
    code: '0100000287',
    objectType: 'ochranné pásmo kolektoru, kabelovodu',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeWidth: 0.18,
  },
  '0100000288': {
    code: '0100000288',
    objectType: 'ochranné pásmo jaderného zařízení',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000289': {
    code: '0100000289',
    objectType: 'ochranné pásmo zařízení protikorozní ochrany',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.18,
  },
  '0100000290': {
    code: '0100000290',
    objectType: 'bezpečnostní pásmo plynovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#4ce600',
    strokeWidth: 0.5,
  },
  '0100000291': {
    code: '0100000291',
    objectType: 'bezpečnostní pásmo zařízení protikorozní ochrany',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.18,
  },
  '0100000292': {
    code: '0100000292',
    objectType: 'ochranné pásmo zařízení odpadového hospodářství',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.18,
  },
  '0100000293': {
    code: '0100000293',
    objectType: 'ochranné pásmo vodního díla I. a II. kategorie z hlediska technickobezpečnostního dohledu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#005ce6',
    strokeWidth: 0.18,
  },
  '0100000294': {
    code: '0100000294',
    objectType: 'ochranné pásmo pozemní komunikace',
    containsPart: 'DI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP dálnice',
        fillColor: '#000000',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP silnice I. třídy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP silnice II. třídy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP silnice III. třídy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP místní komunikace I. třídy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP místní komunikace II. třídy',
        fillColor: '#000000',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP tramvajové dráhy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP pozemní lanové dráhy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP speciální dráhy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP visuté lanové dráhy',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ OP pozemní komunikace',
        attrValue: 'OP trolejbusové dráhy',
        strokeWidth: 0.18,
      },
    ],
  },
  '0100000296': {
    code: '0100000296',
    objectType: 'ochranné pásmo letiště',
    containsPart: 'DI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP se zákazem staveb',
        fillColor: '#000000',
        strokeWidth: 0.25,
      },
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP s výškovým omezením staveb',
        fillColor: '#000000',
        strokeWidth: 0.25,
      },
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP proti nebezpečným a klamavým světlům',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineSvg: 'DI_p_296_op_di_let_svet.svg',
      },
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP se zákazem laserových zařízení',
        fillColor: '#000000',
        strokeWidth: 0.25,
        lineSvg: 'DI_p_296_op_di_let_las_zar.svg',
      },
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP s omezením staveb vzdušných vedení VN a VVN',
        fillColor: '#000000',
        strokeWidth: 0.25,
      },
      {
        attrKey: 'typ OP letiště',
        attrValue: 'OP hlukové',
        fillColor: '#000000',
        strokeColor: '#000000',
        strokeWidth: 0.25,
        lineSvg: 'DI_p_296_op_di_let_ornit.svg',
      },
    ],
  },
  '0100000297': {
    code: '0100000297',
    objectType: 'ochranné pásmo leteckých zabezpečovacích zařízení',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeColor: '#000000',
    lineStyle: 'čárkovaná 2,0 1,0',
    strokeWidth: 0.25,
  },
  '0100000298': {
    code: '0100000298',
    objectType: 'ochranné pásmo stavby pro vodní dopravu',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#0000ff',
    strokeWidth: 0.18,
  },
  '0100000299': {
    code: '0100000299',
    objectType: 'hranice budovy',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.35,
  },
  '0100000300': {
    code: '0100000300',
    objectType: 'hranice stavby',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000301': {
    code: '0100000301',
    objectType: 'hranice schodiště',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000302': {
    code: '0100000302',
    objectType: 'hranice zdi',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 3,0 8,0',
    strokeWidth: 0.18,
  },
  '0100000304': {
    code: '0100000304',
    objectType: 'hranice dopravní stavby\nnebo plochy',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000306': {
    code: '0100000306',
    objectType: 'hranice vodního díla',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.25,
  },
  '0100000308': {
    code: '0100000308',
    objectType: 'hranice udržované zeleně',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000309': {
    code: '0100000309',
    objectType: 'hranice podzemního objektu ZPS',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'čárkovaná 2 1',
    strokeWidth: 0.13,
  },
  '0100000310': {
    code: '0100000310',
    objectType: 'vnitřní členění budov a staveb',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#cccccc',
    lineStyle: 'čárkovaná 1,0 0,5',
    strokeWidth: 0.13,
  },
  '0100000311': {
    code: '0100000311',
    objectType: 'dopravní uzel silniční sítě',
    containsPart: 'DI',
    geometryType: 'bod',
    fillColor: '#000000',
    strokeWidth: 1.7,
    pointSvg: 'DI_b_311_siln_dopr_uzel_dopr_site.svg',
  },
  '0100000312': {
    code: '0100000312',
    objectType: 'souhrnná plocha železničních drah',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#d7d3ed",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000314': {
    code: '0100000314',
    objectType: 'ostatní zastřešená stavba',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d2d2d2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000315': {
    code: '0100000315',
    objectType: 'zastřešení',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.5,
  },
  '0100000316': {
    code: '0100000316',
    objectType: 'ochranné pásmo zařízení elektrické sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e60000',
    strokeWidth: 0.18,
  },
  '0100000317': {
    code: '0100000317',
    objectType: 'ochranné pásmo stanice elektrické sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e60000',
    strokeWidth: 0.18,
  },
  '0100000318': {
    code: '0100000318',
    objectType: 'svodidlo',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeWidth: 0.13,
  },
  '0100000319': {
    code: '0100000319',
    objectType: 'protihluková stěna',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeWidth: 0.13,
  },
  '0100000320': {
    code: '0100000320',
    objectType: 'přidružená plocha pozemní komunikace',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#f5f5f5",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000322': {
    code: '0100000322',
    objectType: 'provozní prostor elektrické sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    strokeWidth: 0.13,
  },
  '0100000323': {
    code: '0100000323',
    objectType: 'vnitřní členění dopravní plochy',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#cccccc',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000325': {
    code: '0100000325',
    objectType: 'pozemní část přístavu',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeColor: '#0000ff',
    lineStyle: 'plná',
    strokeWidth: 1.2,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_325_pozem_cast_pristavu_500.svg, DI_b_325_pozem_cast_pristavu_5000.svg',
      },
    ],
  },
  '0100000328': {
    code: '0100000328',
    objectType: 'trasa plynovodní přípojky',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#4ce600',
    lineStyle: 'plná',
    strokeWidth: 0.13,
  },
  '0100000329': {
    code: '0100000329',
    objectType: 'objekt odvodnění stavby',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    strokeColor: '#646464',
    lineStyle: 'plná',
    strokeWidth: 0.25,
    variants: [
      {
        attrKey: null,
        attrValue: 'linie',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_329_obj_odvod_stavby.svg',
      },
    ],
  },
  '0100000330': {
    code: '0100000330',
    objectType: 'nádrž, zdrž bez vzdouvacího objektu',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: "#e6f6ff",
    pointSvg: 'ZPS_db.svg',
  },
  '0100000331': {
    code: '0100000331',
    objectType: 'hráz',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000332': {
    code: '0100000332',
    objectType: 'jez',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000333': {
    code: '0100000333',
    objectType: 'štěrková přehrážka',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#e6e6e6',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000334': {
    code: '0100000334',
    objectType: 'zatrubněný vodní tok',
    containsPart: 'TI',
    geometryType: 'linie',
    lineStyle: 'čárkovaná 2,0 1,0',
    strokeWidth: 0.5,
  },
  '0100000335': {
    code: '0100000335',
    objectType: 'osa protipovodňové zábrany',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.7,
  },
  '0100000336': {
    code: '0100000336',
    objectType: 'objekt vodovodní sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'vodojem věžový',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'vodojem zemní',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'úpravna vody',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_336_voda_obj_upr.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'čerpací stanice',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_336_voda_obj_cerp_st.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'šachta vodovodní sítě',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_336_voda_obj_sach.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'pítko',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_336_voda_obj_pitko.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'jiný',
        fillColor: '#d9e7ff',
        strokeColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_336_voda_obj_jiny.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'vodojem věžový',
        fillColor: '#005ce6',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_336_voda_obj_vdj.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'vodojem zemní',
        fillColor: '#005ce6',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_336_voda_obj_vdj.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'úpravna vody',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_336_voda_obj_upr.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'čerpací stanice',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_336_voda_obj_cerp_st.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'šachta vodovodní sítě',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_336_voda_obj_sach.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'pítko',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_336_voda_obj_pitko.svg',
      },
      {
        attrKey: 'typ objektu vodovodní sítě',
        attrValue: 'jiný',
        fillColor: '#005ce6',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_336_voda_obj_jiny.svg',
      },
    ],
  },
  '0100000337': {
    code: '0100000337',
    objectType: 'objekt stokové sítě',
    containsPart: 'TI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'čistírna odpadních vod',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'čerpací stanice',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_cerp_st.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'komora odlehčovací',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_odleh_kom.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'komora jiná',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_kan_tech_obj_kom_jina.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'kanalizační výusť',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_kan_tech_obj_vyust.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'retenční nádrž na stokové síti',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_retencni_nadrz.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'podtlaková stanice',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_podtl_st.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'šachta kanalizační',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_sach.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'odlučovač lehkých kapalin',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_odluc.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'jiný',
        fillColor: '#f2e4ce',
        strokeColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
        lineSvg: 'TI_b_337_stok_sit_obj_jiny.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'čistírna odpadních vod',
        fillColor: '#915904',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_337_stok_sit_obj_cov.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'čerpací stanice kanalizační sítě',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_cerp_st.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'komora odlehčovací',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_odleh_kom.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'komora jiná',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_kom_jina.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'kanalizační výusť',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_vyust.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'retenční nádrž na stokové síti',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_retencni_nadrz.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'podtlaková stanice',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_podtl_st.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'šachta kanalizační',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_sach.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'odlučovač lehkých kapalin',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_jiny.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě',
        attrValue: 'jiný',
        fillColor: '#915904',
        strokeWidth: 2.0,
        lineSvg: 'TI_b_337_stok_sit_obj_jiny.svg',
      },
    ],
  },
  '0100000338': {
    code: '0100000338',
    objectType: 'vegetační mísa',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#d4f0c2',
    pointSvg: 'ZPS_db.svg',
  },
  '0100000340': {
    code: '0100000340',
    objectType: 'silniční doprava – místo záměru',
    containsPart: 'DI',
    geometryType: 'bod',
    strokeWidth: 4.0,
    pointSvg: 'DI_b_340_zam_di_sil_misto_zam.svg',
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha',
        strokeWidth: 0.18,
      },
    ],
  },
  '0100000341': {
    code: '0100000341',
    objectType: 'drážní doprava – koridor záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: null,
        attrValue: 'linie',
        fillColor: '#464646',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 2,0 1,5 /\n3,5 7,0',
      },
    ],
  },
  '0100000342': {
    code: '0100000342',
    objectType: 'drážní doprava – místo záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_342_zam_di_zel_misto_zam.svg',
      },
    ],
  },
  '0100000343': {
    code: '0100000343',
    objectType: 'vodní doprava – koridor záměru',
    containsPart: 'DI',
    geometryType: 'linie',
    fillColor: '#0000ff',
    lineStyle: 'čárkovaná 2,0 2,0 / \n4,0 40,0',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha',
        fillColor: '#0000ff',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000344': {
    code: '0100000344',
    objectType: 'vodní doprava – místo záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#0000ff',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        fillColor: '#0000ff',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_344_zam_di_vod_misto_zam.svg',
      },
    ],
  },
  '0100000345': {
    code: '0100000345',
    objectType: 'letecká doprava – koridor záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'linie',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 4,0 2,0',
      },
    ],
  },
  '0100000346': {
    code: '0100000346',
    objectType: 'letecká doprava – místo záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_346_zam_di_let_misto_zam.svg',
      },
    ],
  },
  '0100000347': {
    code: '0100000347',
    objectType: 'cyklistická doprava – koridor záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: null,
        attrValue: 'linie',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 4,0 2,0',
      },
    ],
  },
  '0100000348': {
    code: '0100000348',
    objectType: 'cyklistická doprava – místo záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_348_zam_di_cyklo_misto_zam.svg',
      },
    ],
  },
  '0100000349': {
    code: '0100000349',
    objectType: 'terminál kombinované dopravy – koridor záměru',
    containsPart: 'DI',
    geometryType: 'plocha',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        strokeWidth: 4.0,
        lineSvg: 'DI_b_349_zam_di_kombin_misto_zam.svg',
      },
    ],
  },
  '0100000350': {
    code: '0100000350',
    objectType: 'elektrická síť – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'NN',
        fillColor: '#e60000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VN',
        fillColor: '#e60000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VVN',
        fillColor: '#e60000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'ZVN',
        fillColor: '#e60000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'neurčeno',
        fillColor: '#e60000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'NN',
        fillColor: '#e60000',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VN',
        fillColor: '#e60000',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'VVN',
        fillColor: '#e60000',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'ZVN',
        fillColor: '#e60000',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'maximální napěťová hladina',
        attrValue: 'neurčeno',
        fillColor: '#e60000',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000351': {
    code: '0100000351',
    objectType: 'elektrická síť – místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#e60000',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#e60000',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_351_zam_ti_el_misto_zam.svg',
      },
    ],
  },
  '0100000352': {
    code: '0100000352',
    objectType: 'elektronická komunikace - koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#c500ff',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha (koridor záměru)',
        fillColor: '#c500ff',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000353': {
    code: '0100000353',
    objectType: 'elektronická komunikace - místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#c500ff',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        fillColor: '#c500ff',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_353_zam_ti_ek_misto_zam.svg',
      },
    ],
  },
  '0100000354': {
    code: '0100000354',
    objectType: 'plynovod – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'NTL',
        fillColor: '#4ce600',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'STL',
        fillColor: '#4ce600',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VTL',
        fillColor: '#4ce600',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VVTL',
        fillColor: '#4ce600',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'neurčeno',
        fillColor: '#4ce600',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'NTL',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'STL',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VTL',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'VVTL',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
      },
      {
        attrKey: 'tlaková hladina plynovodní sítě',
        attrValue: 'neurčeno',
        fillColor: '#4ce600',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000355': {
    code: '0100000355',
    objectType: 'plynovod - místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#4ce600',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        fillColor: '#4ce600',
        strokeColor: '#005ce6',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
        lineSvg: 'TI_b_355_zam_ti_plyn_misto_zam.svg',
      },
      {
        attrKey: 'geometrie',
        attrValue: 'plocha',
        fillColor: '#005ce6',
        strokeColor: '#005ce6',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'geometrie',
        attrValue: 'zdroj vody',
        fillColor: '#005ce6',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_zdroj.svg',
      },
      {
        attrKey: 'geometrie',
        attrValue: 'úpravna vody',
        fillColor: '#005ce6',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
      {
        attrKey: 'geometrie',
        attrValue: 'jiný',
        fillColor: '#005ce6',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
      {
        attrKey: 'geometrie',
        attrValue: 'neurčeno',
        fillColor: '#005ce6',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
      {
        attrKey: 'Typ objektu vodovodní sítě – záměru',
        attrValue: 'vodojem',
        fillColor: '#005ce6',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_vdj.svg',
      },
      {
        attrKey: 'Typ objektu vodovodní sítě – záměru',
        attrValue: 'zdroj vody',
        fillColor: '#005ce6',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_zdroj.svg',
      },
      {
        attrKey: 'Typ objektu vodovodní sítě – záměru',
        attrValue: 'úpravna vody',
        fillColor: '#005ce6',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
      {
        attrKey: 'Typ objektu vodovodní sítě – záměru',
        attrValue: 'jiný',
        fillColor: '#005ce6',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
      {
        attrKey: 'Typ objektu vodovodní sítě – záměru',
        attrValue: 'neurčeno',
        fillColor: '#005ce6',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_357_zam_ti_vod_misto_zam_jiny.svg',
      },
    ],
  },
  '0100000358': {
    code: '0100000358',
    objectType: 'kanalizace – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#915904',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha (koridor záměru)',
        fillColor: '#915904',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000359': {
    code: '0100000359',
    objectType: 'kanalizace – místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    variants: [
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'čistírna odpadních vod',
        fillColor: '#915904',
        strokeWidth: 0.18,
      },
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'jiný',
        fillColor: '#915904',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_359_zam_ti_kan_misto_zam_jiny.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'neurčeno',
        fillColor: '#915904',
        strokeWidth: 0.18,
        lineSvg: 'TI_b_359_zam_ti_kan_misto_zam_jiny.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'čistírna odpadních vod',
        fillColor: '#915904',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_359_zam_ti_kan_misto_zam_COV.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'jiný',
        fillColor: '#915904',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_359_zam_ti_kan_misto_zam_jiny.svg',
      },
      {
        attrKey: 'typ objektu stokové sítě – záměru',
        attrValue: 'neurčeno',
        fillColor: '#915904',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_359_zam_ti_kan_misto_zam_jiny.svg',
      },
    ],
  },
  '0100000360': {
    code: '0100000360',
    objectType: 'produktovod – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#73004c',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha',
        fillColor: '#73004c',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000361': {
    code: '0100000361',
    objectType: 'produktovod – místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#73004c',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#73004c',
        strokeColor: '#ff7d00',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 3,0 1,5',
        lineSvg: 'TI_b_361_zam_ti_prod_misto_zam.svg',
      },
      {
        attrKey: null,
        attrValue: 'plocha',
        fillColor: '#ff7d00',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000363': {
    code: '0100000363',
    objectType: 'teplovod – místo záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#ff7d00',
    strokeWidth: 0.18,
    variants: [
      {
        attrKey: null,
        attrValue: 'bod',
        fillColor: '#ff7d00',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_363_zam_ti_tep_misto_zam.svg',
      },
    ],
  },
  '0100000364': {
    code: '0100000364',
    objectType: 'odpadové hospodářství – záměr',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#000000',
    strokeWidth: 0.35,
    variants: [
      {
        attrKey: 'geometrie',
        attrValue: 'linie',
        fillColor: '#000000',
        strokeWidth: 0.5,
        lineStyle: 'čárkovaná 4,0 2,0',
      },
      {
        attrKey: 'geometrie',
        attrValue: 'bod',
        fillColor: '#000000',
        strokeWidth: 4.0,
        lineSvg: 'TI_b_364_zam_ti_skladka_misto_zam.svg',
      },
    ],
  },
  '0100000365': {
    code: '0100000365',
    objectType: 'protipovodňové opatření – koridor záměru',
    containsPart: 'TI',
    geometryType: 'plocha',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.25,
  },
  '0100000366': {
    code: '0100000366',
    objectType: 'přivaděč povrchových vod – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    fillColor: '#005ce6',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha',
        fillColor: '#005ce6',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000367': {
    code: '0100000367',
    objectType: 'sdílená stavba technické infrastruktury – koridor záměru',
    containsPart: 'TI',
    geometryType: 'linie',
    lineStyle: 'čárkovaná 3,0 1,5',
    strokeWidth: 0.5,
    variants: [
      {
        attrKey: null,
        attrValue: 'plocha',
        strokeWidth: 0.35,
      },
    ],
  },
  '0100000368': {
    code: '0100000368',
    objectType: 'ochranné pásmo podzemního zásobníku plynu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#4ce600',
    strokeWidth: 0.18,
  },
  '0100000369': {
    code: '0100000369',
    objectType: 'bezpečnostní pásmo podzemního zásobníku plynu',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#4ce600',
    strokeWidth: 0.5,
  },
  '0100000370': {
    code: '0100000370',
    objectType: 'hranice zařízení vodovodní přípojky',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '0100000371': {
    code: '0100000371',
    objectType: 'hranice zařízení kanalizační přípojky',
    containsPart: 'ZPS',
    geometryType: 'linie',
    fillColor: '#000000',
    strokeColor: '#000000',
    lineStyle: 'plná',
    strokeWidth: 0.18,
  },
  '100000113': {
    code: '100000113',
    objectType: 'trasa vodovodní sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'typ trasy vodovodní sítě',
        attrValue: 'přiváděcí řad',
        fillColor: '#005ce6',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_113_voda_trasa_priv_rad.svg',
      },
      {
        attrKey: 'typ trasy vodovodní sítě',
        attrValue: 'rozvodná vodovodní síť',
        fillColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_113_voda_trasa_rozv_rad.svg',
      },
      {
        attrKey: 'typ trasy vodovodní sítě',
        attrValue: 'jiná',
        fillColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ trasy vodovodní sítě',
        attrValue: 'nezjištěno',
        fillColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '100000121': {
    code: '100000121',
    objectType: 'trasa stokové sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jednotná\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_121_stok_sit_jed_stoka.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'srážková\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_121_stok_sit_srazk_stoka.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'splašková\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_121_stok_sit_splas_stoka.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'průmyslová\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_121_stok_sit_prumysl.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jiné\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'plná',
        lineSvg: 'TI_l_121_stok_sit_nezj_stoka.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'nezjištěno\nstoková síť',
        fillColor: '#915904',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_121_stok_sit_nezj_stoka.svg',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jednotná\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'srážková\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'splašková\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'průmyslová\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jiné\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'nezjištěno\npřiváděcí stoka',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jednotná\njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'srážková\njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'splašková\njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'průmyslová\njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jiné \njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'nezjištěno\njiná',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jednotná\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'srážková\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'splašková\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'průmyslová\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'jiné\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'účelové zařazení stokové sítě\ntyp trasy stokové sítě',
        attrValue: 'nezjištěno\nnezjištěno',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '100000130': {
    code: '100000130',
    objectType: 'trasa teplovodní sítě',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'teplovod\nprimární',
        fillColor: '#ff7d00',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_prim_tepl.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'horkovod\nprimární',
        fillColor: '#ff7d00',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_prim_hork.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'parovod\nprimární',
        fillColor: '#ff7d00',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_prim_paro.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'nezjištěno\nprimární',
        fillColor: '#ff7d00',
        strokeWidth: 0.35,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_prim_nezj.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'teplovod\nsekundární',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_sek_tepl.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'horkovod\nsekundární',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_sek_hork.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'parovod\nsekundární',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_sek_paro.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'nezjištěno\nsekundární',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'čárkovaná 36,0 8,0 [46]',
        lineSvg: 'TI_l_130_teplo_trasa_sek_nezj.svg',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'teplovod\nnezjištěno',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'horkovod\nnezjištěno',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'parovod\nnezjištěno',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ teplovodní sítě\ntyp trasy teplovodní sítě',
        attrValue: 'nezjištěno\nnezjištěno',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '100000137': {
    code: '100000137',
    objectType: 'trasa protikorozní ochrany',
    containsPart: 'TI',
    geometryType: 'linie',
    variants: [
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'plynovod',
        fillColor: '#4ce600',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'vodovod',
        fillColor: '#005ce6',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'kanalizace',
        fillColor: '#915904',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'produktovod',
        fillColor: '#73004c',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'teplovod',
        fillColor: '#ff7d00',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'síť elektronických komunikací',
        fillColor: '#c500ff',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'sdílená',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 0.13,
        lineStyle: 'plná',
      },
    ],
  },
  '100000138': {
    code: '100000138',
    objectType: 'zařízení protikorozní ochrany',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'plynovod',
        fillColor: '#4ce600',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_plyn.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'vodovod',
        fillColor: '#005ce6',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_vod.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'kanalizace',
        fillColor: '#915904',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_kan.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'produktovod',
        fillColor: '#73004c',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_prod.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'teplovod',
        fillColor: '#ff7d00',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_tepl.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'síť elektronických komunikací',
        fillColor: '#c500ff',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_EK.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'sdílená',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_sdil.svg',
      },
      {
        attrKey: 'typ inženýrské sítě s protikorozní ochranou',
        attrValue: 'nezjištěno',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_138_zar_st_ti_trasa_protikor_bod_nezj.svg',
      },
    ],
  },
  '100000139': {
    code: '100000139',
    objectType: 'jiné zařízení staveb TI',
    containsPart: 'TI',
    geometryType: 'bod',
    variants: [
      {
        attrKey: 'typ jiného zařízení staveb TI',
        attrValue: 'hlásič IZS',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_139_zar_st_ti_zar_jine_IZS.svg',
      },
      {
        attrKey: 'typ jiného zařízení staveb TI',
        attrValue: 'reproduktor',
        fillColor: '#000000',
        strokeWidth: 3.5,
        lineSvg: 'TI_b_139_zar_st_ti_zar_jine_repr.svg',
      },
      {
        attrKey: 'typ jiného zařízení staveb TI',
        attrValue: 'venkovní hodiny',
        fillColor: '#000000',
        strokeWidth: 3.0,
        lineSvg: 'TI_b_139_zar_st_ti_zar_jine_hod.svg',
      },
      {
        attrKey: 'typ jiného zařízení staveb TI',
        attrValue: 'nerozlišeno',
        fillColor: '#000000',
        strokeWidth: 1.0,
        lineSvg: 'TI_b_139_zar_st_ti_zar_jine_nerozl.svg',
      },
    ],
  },
  '100000197': {
    code: '100000197',
    objectType: 'podzemní objekt ZPS',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#ffffff',
    strokeColor: '#000000',
    strokeWidth: 0.5,
  },

  // ---------------------------------------------------------------------------
  // JVF DTM 1.5.0.1 — nové objektové typy (9 DTM + 21 PSPI).
  // PROVIZORNÍ styly odvozené z obsahové části (ZPS/TI/DI/PSPI) — barvy nejsou
  // z oficiálního Značkového klíče 1.5.0.1 (ten není součástí JVF distribuce).
  // PSPI (plánované stavby) mají fialový čárkovaný obrys. Při dodání oficiálního
  // katalogu nahradit přesnými kartografickými styly + SVG.
  // ---------------------------------------------------------------------------
  '0100000372': {
    code: '0100000372',
    objectType: 'o6',
    containsPart: 'TI',
    geometryType: 'plocha',
    fillColor: '#fff3e0',
    strokeColor: '#fb8c00',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000373': {
    code: '0100000373',
    objectType: 'technologický portál',
    containsPart: 'DI',
    geometryType: 'linie',
    strokeColor: '#f9a825',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000374': {
    code: '0100000374',
    objectType: 'označník zastávky hromadné dopravy',
    containsPart: 'DI',
    geometryType: 'bod',
    fillColor: '#f9a825',
    strokeColor: '#f9a825',
  },
  '0100000379': {
    code: '0100000379',
    objectType: 'obvod tunelu',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#fffde7',
    strokeColor: '#f9a825',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000380': {
    code: '0100000380',
    objectType: 'horní hrana obruby',
    containsPart: 'ZPS',
    geometryType: 'linie',
    strokeColor: '#42a5f5',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000381': {
    code: '0100000381',
    objectType: 'rozestavěná plocha',
    containsPart: 'ZPS',
    geometryType: 'plocha',
    fillColor: '#eceff1',
    strokeColor: '#42a5f5',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0100000382': {
    code: '0100000382',
    objectType: 'trasa trakčního trolejového vedení',
    containsPart: 'TI',
    geometryType: 'linie',
    strokeColor: '#fb8c00',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0100000387': {
    code: '0100000387',
    objectType: 'hydrant vodovodní sítě',
    containsPart: 'TI',
    geometryType: 'bod',
    fillColor: '#fb8c00',
    strokeColor: '#fb8c00',
  },
  '0100000388': {
    code: '0100000388',
    objectType: 'ochranné pásmo dálnice pro reklamní zařízení',
    containsPart: 'DI',
    geometryType: 'plocha',
    fillColor: '#fffde7',
    strokeColor: '#f9a825',
    lineStyle: 'plná',
    strokeWidth: 0.5,
  },
  '0200000001': {
    code: '0200000001',
    objectType: 'silniční doprava - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000002': {
    code: '0200000002',
    objectType: 'drážní doprava - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000003': {
    code: '0200000003',
    objectType: 'vodní doprava - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000004': {
    code: '0200000004',
    objectType: 'letecká doprava - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000005': {
    code: '0200000005',
    objectType: 'stavba pro pěší - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000006': {
    code: '0200000006',
    objectType: 'cyklistická doprava - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000007': {
    code: '0200000007',
    objectType: 'terminál kombinované dopravy - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000008': {
    code: '0200000008',
    objectType: 'elektrická síť - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000009': {
    code: '0200000009',
    objectType: 'elektronická komunikace - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000010': {
    code: '0200000010',
    objectType: 'plynovod - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000011': {
    code: '0200000011',
    objectType: 'vodovod - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000012': {
    code: '0200000012',
    objectType: 'kanalizace - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000013': {
    code: '0200000013',
    objectType: 'produktovod - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000014': {
    code: '0200000014',
    objectType: 'teplovod - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000015': {
    code: '0200000015',
    objectType: 'odpadové hospodářství - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000016': {
    code: '0200000016',
    objectType: 'protipovodňové a ostatní opatření v krajině - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000017': {
    code: '0200000017',
    objectType: 'přivaděč povrchových vod - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000018': {
    code: '0200000018',
    objectType: 'sdílená stavba TI - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000019': {
    code: '0200000019',
    objectType: 'veřejné prostranství - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000020': {
    code: '0200000020',
    objectType: 'jiná stavba DI - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
  '0200000021': {
    code: '0200000021',
    objectType: 'jiná stavba TI - plánovaná stavba',
    containsPart: 'PSPI',
    geometryType: 'plocha',
    fillColor: '#f3e5f5',
    strokeColor: '#8e24aa',
    lineStyle: 'čárkovaná',
    strokeWidth: 0.5,
  },
};

/**
 * Default colors per ObjektovyTyp.obsahovaCast,
 * used as fallback when codeBase is not found in SYMBOLOGY.
 */
export const FALLBACK_COLORS: Record<string, string> = {
  ZPS: '#64b5f6',
  TI:  '#ff9800',
  DI:  '#ffeb3b',
  GAD: '#66bb6a',
  OPL: '#ce93d8',
  PSPI: '#ab47bc', // plánované stavební práce infrastruktury (1.5.0.1)
};

export const DEFAULT_COLOR = '#90a4ae';

/**
 * Look up symbology for a given codeBase.
 * Returns undefined if not in katalog.
 */
export function getSymbology(codeBase: string): ObjectSymbology | undefined {
  return SYMBOLOGY[codeBase];
}
